// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { last } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import { Timeline, BreadCrumb } from '../../components';

// Actions
import {
    getMerchantInfoRequest,
    fetchPgConfigDetailsRequest,
    fetchRouterDetailsRequest,
    fetchSurchargeDetailsRequest,
    setEntityDataSuccess,
} from '../MerchantOnboard/redux/editMerchant/editMerchant.actions';

import { resetSavedPgs } from '../../containers/MerchantOnboard/redux/pgConfig/pgConfig.actions';

import { onboardingProcessEdit } from './timelineSteps';

const getDraftData = (editData, sectionType) => {
    const filteredData =
        editData &&
        editData.length &&
        editData.find(section => section.type === sectionType);
    return filteredData;
};

const EditViewMerchant = ({
    data,
    actions,
    editData,
    merchantData,
    history: { location },
    permissions,
}) => {
    const { timeline } = data;
    const { fields } = timeline;
    const merchantId = last(location.pathname.split('/'));
    const isViewMode = location.pathname.split('/').includes('view');
    const [onBoardSteps, setOnBoardSteps] = useState(
        onboardingProcessEdit(fields, merchantId, isViewMode, permissions)
    );
    useEffect(() => {
        // Show dialog on explicit route leave
        actions.resetSavedPgs({});
        actions.setEntityDataSuccess({
            aggregator: '',
            franchise: '',
            mle: '',
        });
    }, [actions]);

    useEffect(() => {
        const onBoardSteps = onboardingProcessEdit(
            fields,
            merchantId,
            isViewMode,
            permissions
        );
        setOnBoardSteps(onBoardSteps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData, fields, permissions]);

    const isInEditMode = true;
    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3>Edit merchant</h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Merchant Onboarding',
                            link: '/mob',
                        },
                        {
                            name: 'Edit Merchant',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <div className="left-section">
                    <Timeline onboardingProcess={onBoardSteps} />
                </div>
                <div className="right-section">
                    <Switch>
                        {onBoardSteps.map(tab => (
                            <Route exact path={tab.path} key={tab.tabId}>
                                {tab.component({
                                    ...tab,
                                    draftData: getDraftData(
                                        editData,
                                        tab.sectionType
                                    ),
                                    onBoardSteps,
                                    isInEditMode,
                                })}
                            </Route>
                        ))}
                    </Switch>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ loader, merchantData }) => ({
    loader,
    merchantData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            getMerchantInfoRequest,
            fetchPgConfigDetailsRequest,
            fetchRouterDetailsRequest,
            fetchSurchargeDetailsRequest,
            setEntityDataSuccess,
            resetSavedPgs,
        },
        dispatch
    ),
});
EditViewMerchant.propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.object,
    merchantData: PropTypes.object,
    editData: PropTypes.array,
    history: PropTypes.object,
    permissions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditViewMerchant);
